import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { 
  IVideoGuide, 
  VideoGuideResponse, 
  VideoGuideListResponse 
} from '../models/video-guide.model';

@Injectable({
  providedIn: 'root'
})
export class VideoGuideService {
  
  constructor(private http: HttpClient) {}

  // Create a new video guide
  createVideoGuide(videoGuide: IVideoGuide): Observable<VideoGuideResponse> {
    return this.http.post<VideoGuideResponse>(`${environment.apiUrl}/video-guides/create`, videoGuide);
  }

  // Get all video guides
  getAllVideoGuides(): Observable<VideoGuideListResponse> {
    return this.http.get<VideoGuideListResponse>(`${environment.apiUrl}/video-guides/get-all`);
  }

  // Get video guide by ID
  getVideoGuideById(id: string): Observable<VideoGuideResponse> {
    return this.http.get<VideoGuideResponse>(`${environment.apiUrl}/video-guides/${id}`);
  }

  // Update video guide
  updateVideoGuide(id: string, videoGuide: Partial<IVideoGuide>): Observable<VideoGuideResponse> {
    return this.http.put<VideoGuideResponse>(`${environment.apiUrl}/video-guides/${id}`, videoGuide);
  }

  // Delete video guide
  deleteVideoGuide(id: string): Observable<VideoGuideResponse> {
    return this.http.delete<VideoGuideResponse>(`${environment.apiUrl}/video-guides/${id}`);
  }
} 